import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="section-large bg-dark">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Client Testimonials
          </h2>
          <div className="w-20 h-1 bg-accent-teal mx-auto mb-6"></div>
          <p className="text-lg text-neutral-silver max-w-2xl mx-auto">
            Hear what our clients have to say about working with us
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="flex flex-col h-full">
                <div className="mb-6">
                  <Quote size={32} className="text-accent-violet opacity-50" />
                </div>
                <p className="text-neutral-silver leading-relaxed mb-6 flex-1">
                  "{testimonial.content}"
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-accent-teal/20 flex items-center justify-center text-accent-teal font-bold">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <h4 className="text-white font-bold">{testimonial.name}</h4>
                    <p className="text-neutral-silver text-sm">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
